module.exports = "<a class=\"logout\" (click)=\"logout()\">\n    <i class=\"fa fa-power-off fa-2x\" aria-hidden=\"true\" data-toggle=\"popover\" title=\"Logout\" data-content=\"Logout\"></i>\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout.component.html
// module id = ./src/app/logout.component.html
// module chunks = main